<template>
  <div>
    <vx-card class="mb-1" :collapseAction="true" title="Filtro">
       <vs-row vs-type="flex" vs-justify="space-between" class="mb-2">         
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">         
              <label class="vs-input--label mr-2">Nome do Cliente</label>                            
              <v-select          
                  label="nome"                                                 
                  :options="listaFavorecido"                   
                  v-model="filtro.idFavorecido" 
                  :reduce="f => f.id"    
                  :filter="pesquisarFavorecido"                           
                  class="v-select w-full"
                  style="padding-right: 5px;" >
                  <template v-slot:option="option">                        
                      <span style='font-family: Verdana, sans-serif;'> {{ option.nome }} </span> <br/> {{ option.cpfCNPJ }}  - {{ option.razaoSocial }}
                  </template>
              </v-select>   
          </vs-col>          
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label mr-2">Número da Conta</label>              
              <vs-input class="w-full" v-model="filtro.numeroConta" @keyup.enter="fetchLista()" style="padding-right: 5px;" />
          </vs-col>
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label mr-2">Número do Lançamento</label>              
              <vs-input class="w-full" v-model="filtro.numeroLancamento" @keyup.enter="fetchLista()" style="padding-right: 5px;"/>
          </vs-col>
           <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label mr-2">Nota Fiscal</label>              
              <vs-input class="w-full" v-model="filtro.numeroNotaFiscal" @keyup.enter="fetchLista()" />
          </vs-col>
       </vs-row>
       <vs-row vs-type="flex" vs-justify="space-between" class="mb-2">                   
          <vs-col vs-justify="flex-start" vs-align="center" vs-w="4">       
            <label class="vs-input--label mr-2">Período</label>              
            <div class="flex items-center">
              <flat-pickr v-model="filtro.dataInicio" :config="configDatePicker" />
              <label class="vs-input--label mr-2">à</label>
              <flat-pickr v-model="filtro.dataFim" :config="configDatePicker"/>
            </div>           
          </vs-col>          
           <vs-col vs-justify="flex-start" vs-align="center" vs-w="3"> 
             <label class="vs-input--label">Status</label>              
             <v-select                                               
                :options="CONSTANTE_STATUS_CONTA" 
                v-model="filtro.statusConta"      
                :reduce="d => d.data"                              
                class="v-select w-full"
                style="padding-right: 5px;" >
             </v-select>
          </vs-col>
           <vs-col vs-justify="flex-start" vs-align="center" vs-w="2">         
              <label class="vs-input--label mr-2">Complemento</label>              
              <vs-input class="w-full" v-model="filtro.complemento" @keyup.enter="fetchLista()" style="padding-right: 5px;" />
          </vs-col>
           <vs-col vs-justify="flex-start" vs-align="center" vs-w="3">         
              <label class="vs-input--label">Unidade</label>              
              <vs-input class="w-full" v-model="filtro.nomeUnidadeOperacional" @keyup.enter="fetchLista()" />
          </vs-col>
       </vs-row>
       <vs-row vs-type="flex" vs-justify="space-between" >
          <vs-col vs-type="flex" vs-w="6" vs-justify="center">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-left" @click="setMes(false)"> </vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-calendar" @click="setMesAtual"></vs-button>
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" size="small" icon="icon-arrow-right" @click="setMes(true)"> </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
            <vs-button class="mr-2" color="primary" type="filled" icon-pack="feather" icon="icon-search" @click="fetchLista()"></vs-button>
            <vs-button class="mr-2" color="dark" type="border" icon-pack="feather" icon="icon-file" @click="limparFiltros"></vs-button>  
            <vs-button class="mr-2" color="warning" type="filled" icon-pack="feather" icon="icon-plus" @click="routeNovoRegistro" v-if="isPodeInserir"></vs-button>          
            <vs-button color="rgb(11, 189, 135)" type="filled" icon-pack="feather" icon="icon-save" @click="exportarParaCSV"></vs-button>          
          </vs-col>
      </vs-row>
    </vx-card>
    <div class="flex">
      <h6 class="mt-2 mb-2 text-danger"> [ {{dadosDaGrid.length }} ] </h6>
      <h6 class="ml-auto mt-2 mb-2 text-primary" > Faturado: {{totalFaturadoFormatado}} </h6>
      <h6 class="ml-2 mt-2 mb-2 text-success" > Pago: {{totalPagoFormatado}} </h6>
      <h6 class="ml-2 mt-2 mb-2 text-danger" > - Em Aberto: {{totalEmAbertoFormatado}}</h6>
      <h6 class="ml-2 mt-2 mb-2 text-danger" > - Vencido: {{totalVencidoFormatado}} </h6>
      <h6 class="ml-2 mt-2 mb-2 text-primary" > - Provisório: {{totalProvisorioFormatado}} </h6>
    </div>
    
    <vx-card class="mb-1">
      <ag-grid-vue
        ref="agGridTable"           
        :gridOptions="configuracaoGrid.gridOptions"
        class="ag-theme-material ag-grid-table ag-grid-altura"
        :columnDefs="configuracaoGrid.columnDefs"
        :defaultColDef="configuracaoGrid.defaultColDef"
        :rowData="dadosDaGrid"
        :rowHeight="38"
        :headerHeight="25"        
        rowSelection="single"
        colResizeDefault="shift"
        @row-selected="onRowSelectedRegistro"    
        :animateRows="true"
        :floatingFilter="false"
        :pagination="false"
        :paginationAutoPageSize="false"
        :suppressPaginationPanel="true"
        >
      </ag-grid-vue>      
    </vx-card>
    
  </div>

</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'

const URL_SERVLET = "/Conta/ListarConta";
const NAME_ROUTE_EDIT = "financeiro-contas-a-receber-editar";

import { CONSTANTE_STATUS_CONTA } from '@/constantesComboBox.js'

export default {
  components: {
    AgGridVue,
    flatPickr
  },
  data() {
    return {
      filtro : { dataInicio:  null,dataFim : null, statusConta: null, idFavorecido: null, nomeContaPlanoConta: null, numeroConta: null, 
       numeroLancamento: null, nomeUnidadeOperacional: null, complemento: null },
      configuracaoGrid: { 
          gridApi: null, 
          gridOptions: {
            rowClassRules: {          
              'rag-green-outer': function(params) { return params.data.status === 'PROVISORIA'; },
              'rag-amber-outer': function(params) { return params.data.isVencida; },
              'rag-cancelada':   function(params) { return params.data.status === 'CANCELADA'; },
            },
          }, 
          defaultColDef: { sortable: true, resizable: true, suppressMenu: true  },
          columnDefs: [        
            { headerName: 'N.', field: 'numeroConta', width: 35, cellRenderer: function(params) { return "<strong>" + params.data.numeroConta+ "</strong>"},
                cellStyle: params => {
                    if (params.data.status === 'PAGA') {                        
                        return {color: 'green', 'text-decoration': 'line-through'};
                    }
                    return null;
                } },                       
            { headerName: 'UNIDADE', field: 'unidadeOperacional.nome', width: 45},
            { headerName: 'VENCIMENTO', field: 'vencimentoFormatado', width: 45},                
            { headerName: 'VALOR', field: 'valor', width: 60, cellRenderer: function(params) { 
                  let valorAExibir = "";
                  if (params.data.valor === params.data.valorAtualizado) {
                    valorAExibir = generico.formatarMoedaReal(params.data.valorAtualizado);
                  } else {
                    valorAExibir = generico.formatarMoedaReal(params.data.valorAtualizado) + " <span style='font-size: x-small'> [ " + generico.formatarNumero(params.data.valor) +" ] </span>";
                  }
                  return valorAExibir + (params.data.numeroNotaFiscal ? "<br/> <span style='font-size: x-small'> NF: " + params.data.numeroNotaFiscal + "</span>": "")
                },
                cellStyle: params => {
                    if (params.data.status === 'PAGA') {                        
                        return {color: 'green'};
                    }
                    return null;
                }
            },  
            { headerName: 'EM ABERTO', field: 'valor', width: 60, cellRenderer: function(params) { 
                  let valorAExibir = "";
                  if (params.data.saldoEmAberto === params.data.saldoEmAbertoAtualizado) {
                    valorAExibir = generico.formatarMoedaReal(params.data.saldoEmAberto);
                  } else {
                    valorAExibir = generico.formatarMoedaReal(params.data.saldoEmAbertoAtualizado) + " <span style='font-size: x-small'> [ " + generico.formatarNumero(params.data.saldoEmAberto) +" ] </span>";
                  }
                  return valorAExibir;
                },
                cellStyle: params => {
                    if (params.data.status === 'PAGA') {                        
                        return {color: 'green'};
                    }
                    return null;
                }
            },                            
            { headerName: 'CLIENTE', field: 'favorecido.nome'},                
            { headerName: 'CONTA', field: 'contaPlanoConta.nome', width: 150, cellRenderer : function(params) {
                  return params.data.contaPlanoConta.nome + (params.data.complemento ? "<br/> <small>" + params.data.complemento + "</small>": ""); 
                } 
            },
            { headerName: 'STATUS', field: 'status', width: 75},                
            { headerName: 'NOTA FISCAL', field: 'numeroNotaFiscal', width: 45, hide: true},                
            { headerName: 'COMPLEMENTO', field: 'complemento', width: 45, hide: true},                
          ]
      },
      configDatePicker: {          
          altInput: true,
          altFormat: "d-m-Y",
          dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal hasValue text-center mr-2",
          locale: PortugueseLocale
      },
      dadosDaGrid: [],
      totalRegistros: 0,
      numeroMesAtual: 0,
      totalFaturado: 0,
      totalPago: 0,
      totalEmAberto: 0,
      totalProvisorio: 0,
      totalVencido: 0,
      listaFavorecido: []
     
    }
  },  
  created() {
    this.CONSTANTE_STATUS_CONTA = CONSTANTE_STATUS_CONTA;
  },
  computed: {
    totalFaturadoFormatado() {
      return generico.formatarMoedaReal(this.totalFaturado);
    },
    totalPagoFormatado() {
      return generico.formatarMoedaReal(this.totalPago);
    },
    totalEmAbertoFormatado() {
      return generico.formatarMoedaReal(this.totalEmAberto);
    },
    totalProvisorioFormatado() {
      return generico.formatarMoedaReal(this.totalProvisorio);
    },    
    totalVencidoFormatado() {
      return generico.formatarMoedaReal(this.totalVencido);
    },
    isGestor() {
			return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
		},
    isPodeInserir() {
       let permissao = false;
       if ( (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER') ||
            (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO') ||             
            (this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA') ||
            (this.$store.state.AppActiveUser.perfil === 'GESTOR') ) {
            permissao =  true;   
        }

        return permissao;
    }
  },
  methods: {   
    pesquisarFavorecido(options, varTermoPesquisa) {
        if (!varTermoPesquisa) {
            return;
        }
        varTermoPesquisa = varTermoPesquisa.toUpperCase();
        return options.filter(function (c) {
            return ( ( String(c.nome).toUpperCase().indexOf(varTermoPesquisa) != -1)  || (String(c.razaoSocial).toUpperCase().indexOf(varTermoPesquisa) != -1) || 
            ( String(c.cpfCNPJ).indexOf(varTermoPesquisa) != -1));
        })
    }, 
    setMes(incrementar){
      
      if (incrementar) {
        this.numeroMesAtual = this.numeroMesAtual + 1;
      } else {
        this.numeroMesAtual = this.numeroMesAtual - 1;
      }

      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth() + this.numeroMesAtual, 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1 + this.numeroMesAtual, 0);


      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    },
    setMesAtual(){
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
      this.numeroMesAtual = 0;
    },
    limparFiltros() {
      this.filtro = {dataInicio:  null,dataFim : null, statusConta: null, idFavorecido: null, nomeContaPlanoConta: null, numeroConta: null, 
       numeroLancamento: null, nomeUnidadeOperacional: null,complemento: null };      
    },
    areDatesInSameYearAndMonth(date1, date2) {
        // Função para extrair ano e mês de uma string no formato Y-m-d
        function extractYearAndMonth(dateStr) {
            const [year, month] = dateStr.split('-');
            return { year: parseInt(year, 10), month: parseInt(month, 10) };
        }

        // Extraindo ano e mês de cada data
        const date1Parts = extractYearAndMonth(date1);
        const date2Parts = extractYearAndMonth(date2);

        // Comparando ano e mês
        return date1Parts.year === date2Parts.year && date1Parts.month === date2Parts.month;
    },
    fetchLista() {  
      if (!this.isGestor && !this.filtro.idFavorecido) {
         this.$vs.notify({
              title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'danger',
              text: "Informe o nome do cliente para realizar a pesquisa.",
          });
        return;
      }  

      if (!this.filtro.dataInicio ||  !this.filtro.dataFim) {
         this.$vs.notify({
              title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'danger',
              text: "Informe o período para realizar a pesquisa.",
          });
        return;
      } else if (!this.isGestor && !this.filtro.idFavorecido && this.filtro.dataInicio && this.filtro.dataFim) {          
          if (!this.areDatesInSameYearAndMonth(this.filtro.dataInicio, this.filtro.dataFim)) {
            this.$vs.notify({
                title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'danger',
                text: "Informe o período dentro do mesmo mês para realizar a pesquisa.",
            });
            return;
          }         
          
      }

      this.$vs.loading() 
      const params = new URLSearchParams();
      params.append('pagina', -1);
      params.append("contaPlanoConta.grupoPlanoConta.tipo", "RECEITA");
      
      if(this.filtro.dataInicio != null){
        params.append("vencimentoInicio", this.filtro.dataInicio);
      }
      
      if(this.filtro.dataFim != null){
        params.append("vencimentoFim", this.filtro.dataFim);
      }

      if (this.filtro.statusConta) {
        params.append("status", this.filtro.statusConta);
      }

      if (this.filtro.idFavorecido) {
        params.append("favorecido.id", this.filtro.idFavorecido);
      }
      if (this.filtro.nomeContaPlanoConta) {
        params.append("contaPlanoConta.nome", this.filtro.nomeContaPlanoConta);
      }
            
      if (this.filtro.numeroConta) {
        params.append("numeroConta", this.filtro.numeroConta);	
      }

      if (this.filtro.numeroNotaFiscal) {
        params.append("numeroNotaFiscal", this.filtro.numeroNotaFiscal);	
      }

      if (this.filtro.numeroLancamento) {
        params.append("numeroLancamentoPesquisa", this.filtro.numeroLancamento);	
      }
      
      if (this.filtro.nomeUnidadeOperacional) {
        params.append("unidadeOperacional.nome",  this.filtro.nomeUnidadeOperacional);
      }

      if (this.filtro.complemento) {
        params.append("complemento",  this.filtro.complemento);
      }

      axios.post(URL_SERVLET, params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/' });
          } else {
              this.totalRegistros = response.data.Resultado.quantidade;              
              this.dadosDaGrid = response.data.Resultado.lista;                                    

              this.totalFaturado = 0;
              this.totalPago = 0; 
              this.totalEmAberto = 0;
              this.totalProvisorio = 0;
              this.totalVencido = 0;

              if (this.totalRegistros > 0) {
                 let registro = null;
                 for(let j=0; j < this.dadosDaGrid.length; j++) {  
                    registro = this.dadosDaGrid[j];
                    if (registro.status == 'ABERTA') {
                        this.totalEmAberto = this.totalEmAberto + parseFloat(registro.valor);
                        if (registro.isVencida) {
                          this.totalVencido = this.totalVencido + parseFloat(registro.valorAtualizado);
                        }
                    } else if (registro.status == 'PAGA') {
                        this.totalPago = this.totalPago + parseFloat(registro.valor);
                    } else if (registro.status == 'PROVISORIA') {
                        this.totalProvisorio = this.totalProvisorio + parseFloat(registro.valor);
                    }

                    if (registro.status == 'ABERTA' || registro.status == 'PAGA' || registro.status == 'PROVISORIA') {
                        this.totalFaturado = this.totalFaturado + parseFloat(registro.valor);
                    }

                 }
              } 
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - fetchLista - " + error); 
      })    
                        
    },
    routeNovoRegistro() {
      let self_ = this;

      self_.$router.push({
            name: NAME_ROUTE_EDIT                     
      })
    },
    onRowSelectedRegistro(evento) {
      let self_ = this;
      let registro = evento.node.data;
      
      self_.$router.push({
            name: NAME_ROUTE_EDIT,
            params: {
              registroOriginal: registro
            }
      })

    },
    exportarParaCSV() {
      var params = {columnSeparator: ';', fileName: 'ContasAReceber.csv',  allColumns: true};
      this.configuracaoGrid.gridApi.exportDataAsCsv(params);
    },
    fetchListaFavorecido() {      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('ehCliente',  true);
            
      axios.post("/Favorecido/ListarFavorecido", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
            this.listaFavorecido = response.data.Resultado.lista;
          }
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })                
    }, 
    
  },
  mounted() {
    if (this.$store.getters.filtroContasAReceber) {
        this.filtro = JSON.parse(JSON.stringify(this.$store.getters.filtroContasAReceber));
    } else {
      var date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.filtro.dataInicio = firstDay.toISOString().split('T')[0];
      this.filtro.dataFim = lastDay.toISOString().split('T')[0];
    }

    this.fetchListaFavorecido();
    this.configuracaoGrid.gridApi = this.configuracaoGrid.gridOptions.api;
    this.configuracaoGrid.gridApi.sizeColumnsToFit();      
    if ((this.$store.state.AppActiveUser.perfil !== 'CRM_CONTA_RECEBER') ) {
      this.fetchLista(this.filtro);    
    }
  },
  beforeDestroy() {    
    this.$store.dispatch('setarFiltro', {nomeTela: 'contasAReceber' , filtro: this.filtro});
  }
}

</script>
<style lang="scss" scoped>
  .ag-grid-altura{
    max-height: calc(100vh - 410px);
  }
</style>

<style lang="scss">
  
  .rag-green-outer {
    background-color: rgb(252, 222, 196) !important;
  }

  .rag-amber-outer {
    background-color: rgb(218, 84, 84) !important;
    color: white  !important;
  }

  .rag-cancelada {
     color: grey !important;
     background-color: rgb(231, 233, 203) !important;
     text-decoration: line-through !important;
  }
</style>